import React, { useRef } from 'react';
import Icon from 'shared/icons/IconComponent';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const SearchInput = ({
  onSearch,
  placeholder,
  disabled,
  keys = [],
  ...inputProps
}) => {
  const input = useRef(null);

  const _handleKeyDown = e => {
    const key = e.key.toLowerCase();
    const keysToSearch = ['enter', ...keys.map((k) => k.toLowerCase())];
    if (keysToSearch.includes(key)) {
      onSearch(e.target.value);
    }
  };

  const handleClick = () => {
    const value = input && input.current ? input.current.value : '';
    onSearch(value);
  };

  return (
    <div className='search-input'>
      <input
        className='input'
        ref={input}
        disabled={disabled}
        placeholder={placeholder || 'Search...'}
        onKeyDown={_handleKeyDown}
        {...inputProps}
        value={inputProps.value || ''}
      />
      <button
        type="button"
        className='button primary large'
        disabled={disabled}
        onClick={handleClick}
      >
        <Icon icon='search' />
      </button>
    </div>
  );
};

export default SearchInput;
